import { useMemo } from 'react';
import { useDeepMemoize } from './useDeepMemoize';

/* eslint-disable react-hooks/exhaustive-deps */
/**
 * Same as useMemo, but dependencies are deep-compared.
 * Warning: eslint assistance is not available when using this hook.
 *
 * @param effect
 * @param dependencies
 */
export const useDeepMemo = (factory, dependencies) =>
	useMemo(factory, useDeepMemoize(dependencies));
